/**
 * Return a compact "X ago" / "in X" string relative to now.
 *
 *   timeAgo(Date.now() - 3000)   // "3s ago"
 *   timeAgo(Date.now() - 180000) // "3m ago"
 *   timeAgo(Date.now() - 7200000) // "2h ago"
 *   timeAgo(Date.now() + 600000)  // "in 10m"
 *
 * Accepts a Date, ISO string, or epoch number. Returns "" for
 * falsy / unparseable input so callers can `value && `timeAgo(...)``.
 */
export default function timeAgo(input) {
  if (!input && input !== 0) return "";
  const date = input instanceof Date ? input : new Date(input);
  const ms = date.getTime();
  if (!Number.isFinite(ms)) return "";

  const diffSec = Math.round((Date.now() - ms) / 1000);
  const abs = Math.abs(diffSec);
  const sign = diffSec >= 0 ? "ago" : "in";
  const n = (v) => Math.round(v);

  let text;
  if (abs < 60)      text = `${n(abs)}s`;
  else if (abs < 3600)   text = `${n(abs / 60)}m`;
  else if (abs < 86400)  text = `${n(abs / 3600)}h`;
  else if (abs < 2592000) text = `${n(abs / 86400)}d`; // < 30 days
  else if (abs < 31536000) text = `${n(abs / 2592000)}mo`;
  else                    text = `${n(abs / 31536000)}y`;

  return sign === "in" ? `in ${text}` : `${text} ago`;
}
